<template>
  <div class="SVGbox" id="check">
    <svg
      width="16px"
      height="12px"
      viewBox="0 0 16 12"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <path
          d="M8.24999441,14.85 L5.04166107,11.6416667 C4.68727836,11.287284 4.11271045,11.287284 3.75832774,11.6416667 L3.75832774,11.6416667 C3.40394502,11.9960494 3.40394502,12.5706173 3.75832774,12.925 L7.60181319,16.7684855 C7.95979379,17.1264661 8.54019502,17.1264661 8.89817562,16.7684855 L18.6083277,7.05833333 C18.9627105,6.70395062 18.9627105,6.12938271 18.6083277,5.775 L18.6083277,5.775 C18.253945,5.42061729 17.6793771,5.42061729 17.3249944,5.775 L8.24999441,14.85 Z"
          id="path-1"
        ></path>
      </defs>
      <g id="2019" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="/mobile/2_2" transform="translate(-139.000000, -392.000000)">
          <g id="Group-2" transform="translate(16.000000, 209.000000)">
            <g id="Button-@Buttons.Small" transform="translate(112.000000, 174.000000)">
              <g id="done_24" transform="translate(8.000000, 4.000000)">
                <mask id="mask-2" fill="white">
                  <use xlink:href="#path-1"></use>
                </mask>
                <use id="Icon" :fill="color" fill-rule="nonzero" xlink:href="#path-1"></use>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: "asset-check",
  props: ["color"]
};
</script>

<style scoped>
#check {
  display: block;
  float: left;
  margin-right: 9px;
  position: relative;
  top: 1px;
}
</style>



// WEBPACK FOOTER //
// src/assets/check.vue